import { useEffect } from 'react';

export const useDebouncedEffect = (effect: () => void, delay: number, dependencies: ReadonlyArray<any>) => {
    useEffect(
        () => {
            // Call effect after delay
            const handler = setTimeout(effect, delay);

            // Cancel the timeout if dependency changes (also on delay change or unmount)
            // The next effect call as a result of the change will set a new timer.
            return () => clearTimeout(handler);
        },
        [delay, ...dependencies] // Only re-call effect if delay or dependencies changes
    );
};
